<app-modal [info]="info" (closeModal)="closeModal($event)" (onSubmit)="onSubmit()">
  <ng-template #scrollableContent>
    <div class="folders">
      @for (folder of form.value; track folder) {
        <app-folder-card-small
          class="folders__item"
          [type]="'withPicture'"
          [folder]="folder"
          [candidateFullName]="data.candidate.fullName"
          [defaultColor]="data.defaultColor"
          [candidatePicture]="candidatePictureUrl$ | async"
          (toggleCandidate)="toggleCandidateToFolder(folder)"></app-folder-card-small>
      }
    </div>
  </ng-template>
</app-modal>
